module.exports = __webpack_public_path__ + "static/media/bauddhikgeeks.f2d490dc.png";